<template>
  <NavbarApp />

  <div class="contact-page-alt">
   
    <div class="content-wrapper">
      <div class="contact-info-block">
        <div class="info-item">
          <img src="../assets/contact/map-pin.svg" alt="Map Pin Icon" class="info-icon" />
          <div class="info-text">
            <p class="info-title"><strong>{{ $t('contactPage.companyNameMap') }}</strong></p>
            <p class="info-subtitle">Mun. București, Str. Căderea Bastiliei nr. 33, Sector 1, cod poștal 010613, România</p>
            <a href="https://www.google.com/maps/search/?api=1&amp;query=Strada+C%C4%83derea+Bastiliei+33%2C+Sector+1%2C+Bucure%C8%99ti+010613%2C+Rom%C3%A2nia" target="_blank" rel="noopener noreferrer" class="info-link">{{ $t('contactPage.viewOnMap') }}</a>
          </div>
        </div>

        <div class="info-item">
          <img src="../assets/contact/mail.svg" alt="Mail Icon" class="info-icon" />
          <div class="info-text">
            <p class="info-title">office@islaw.ro</p>
           
          </div>
        </div>

        <div class="info-item">
          <img src="../assets/contact/phone-svgrepo-com.svg" alt="Phone Icon" class="info-icon" />
          <div class="info-text">
            <p class="info-title">0213 140 254</p>
           
          </div>
        </div>
      </div>

      <div class="map-block">
        <div class="map-embed-alt">
          <iframe
            v-if="allowExternalMedia"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.749033282276!2d26.09633647610057!3d44.43657787107775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b201f11c759715%3A0xb36b5665b1c5a935!2sStrada%20C%C4%83derea%20Bastiliei%2033%2C%20Bucure%C8%99ti%20010613!5e0!3m2!1sen!2sro!4v1716801833076!5m2!1sen!2sro"
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            title="Location on Google Maps"
          ></iframe>
          <div v-else class="map-consent-placeholder">
            <img src="../assets/contact/map-pin.svg" alt="" class="map-consent-icon" />
            <p class="map-consent-title">{{ $t('contactPage.mapConsent.title') }}</p>
            <p class="map-consent-text">{{ $t('contactPage.mapConsent.description') }}</p>
            <button type="button" class="map-consent-btn" @click="grantExternalMedia">
              {{ $t('contactPage.mapConsent.loadButton') }}
            </button>
            <router-link to="/cookiepolicy" class="map-consent-policy-link">
              {{ $t('contactPage.mapConsent.policyLink') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Section4 />
</template>

<script>
import NavbarApp from '../components/HomePage/navbar-law.vue';
import Section4 from '../components/HomePage/section-4.vue';
import { useCookieConsent } from '../composables/useCookieConsent.js';

export default {
  name: 'ContactPage',
  components: {
    NavbarApp,
    Section4
  },
  setup() {
    const { allowExternalMedia, grantExternalMedia } = useCookieConsent();
    return { allowExternalMedia, grantExternalMedia };
  }
}
</script>

<style scoped>
/*
--- Overall Page Container ---
*/
.contact-page-alt {
  min-height: 50vh; /* Ensures content pushes Section4 down */
  display: flex;
  flex-direction: column;
  align-items: center; /* Center content horizontally */
  padding: 40px 20px; /* Top/bottom padding and side padding */
  box-sizing: border-box;  
  color: #333;
  background-color: #ffffff; /* Light background for the whole page */
  margin-top: 60px; /* Space from Navbar */
}

.page-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 60px; /* More space below the main title */
  text-align: center;
  width: 80%;
}

/*
--- Main Content Wrapper (Contact Info + Map) ---
*/
.content-wrapper {
  display: flex;
  flex-direction: row; /* Default: horizontal layout for larger screens */
  width: 90%; /* Content width */
  max-width: 1200px; /* Max width for readability */
  gap: 40px; /* Space between info block and map block */
  align-items: flex-start; /* Align content to the top */
  background-color: #fff; /* White background for the main content area */
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08); /* More pronounced shadow */
  padding: 40px; /* Inner padding for the wrapper */
  box-sizing: border-box;
  margin-bottom: 40px; /* Space before Section4 */
}

/*
--- Contact Information Block ---
*/
.contact-info-block {
  flex: 1; /* Takes available space */
  display: flex;
  flex-direction: column;
  gap: 30px; /* Space between each info item */
}

.info-item {
  display: flex;
  align-items: flex-start; /* Align icon and text to the top */
  gap: 15px; /* Space between icon and text content */
}

.info-icon {
  width: 48px; /* Slightly larger icon size */
  height: 48px;
  flex-shrink: 0;
  color: #bbd55a; /* This color will only apply if the SVG is inline or styled as such */
}

.info-text {
  flex-grow: 1;
  text-align: left; /* Default alignment */
}

.info-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #444;
  margin-bottom: 5px;
  line-height: 1.3; /* Adjust line height for better readability */
}

.info-title strong {
  font-size: 1.4rem; /* Make company name slightly larger */
}

.info-subtitle {
  font-size: 1.05rem;
  color: #666;
  line-height: 1.5;
  margin-bottom: 8px; /* Space between subtitle and link */
}

.info-link {
  font-size: 1rem;
  color: #bbd55a;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease, text-decoration 0.3s ease;
}

.info-link:hover {
  color: #a0c24a;
  text-decoration: underline;
}

/*
--- Map Block ---
*/
.map-block {
  flex: 1.5; /* Map takes more space than info block */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  overflow: hidden; /* Ensure iframe corners are rounded */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08); /* Subtle shadow for map */
}

.map-embed-alt {
  width: 100%;
  padding-bottom: 75%; /* Aspect ratio: 4:3 (height is 75% of width) */
  position: relative;
  overflow: hidden;
}

.map-embed-alt iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/*
--- Map Consent Placeholder (shown until Google Maps cookies are accepted) ---
*/
.map-consent-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #f4f6f0;
  border: 1px dashed #c9d69a;
  border-radius: 8px;
}

.map-consent-icon {
  width: 42px;
  height: 42px;
  opacity: 0.8;
}

.map-consent-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.map-consent-text {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  max-width: 420px;
  margin: 0;
}

.map-consent-btn {
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 12px 28px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #bbd55a;
  color: #1c1c1c;
  transition: background-color 0.3s ease;
  margin-top: 6px;
}

.map-consent-btn:hover {
  background-color: #a0c24a;
}

.map-consent-policy-link {
  font-size: 0.85rem;
  color: #888;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.map-consent-policy-link:hover {
  color: #a0c24a;
}

/*
--- Responsive Design ---
*/

/* Tablets and Smaller Desktops (e.g., 1024px and below) */
@media (max-width: 1024px) {
  .page-title {
    font-size: 2.8rem;
    margin-bottom: 40px;
  }

  .content-wrapper {
    flex-direction: column; /* Stack contact info and map vertically */
    width: 95%;
    padding: 30px;
    gap: 30px; /* Reduce gap when stacked */
  }

  .contact-info-block {
    gap: 25px;
  }

  .info-item {
    align-items: center; /* Center icon and text vertically when stacked */
    flex-direction: row; /* Keep icon and text side-by-side even on tablets */
  }

  .info-icon {
    width: 40px;
    height: 40px;
  }

  .info-title {
    font-size: 1.2rem;
  }

  .info-subtitle,
  .info-link {
    font-size: 0.95rem;
  }

  .map-block {
    flex: none; /* Remove flex sizing when stacked */
    width: 100%; /* Take full width */
    height: 350px; /* Fixed height for map on tablets when stacked */
    box-shadow: none; /* Reduce shadow when map is stacked */
    border-radius: 8px; /* Maintain rounded corners */
  }
  .map-embed-alt {
    padding-bottom: 0; /* Remove aspect ratio padding when fixed height */
    height: 100%; /* Take full height of map-block */
  }
}

/* Mobile Devices (e.g., 768px and below) */
@media (max-width: 768px) {
  .contact-page-alt {
    padding: 30px 15px; /* Adjust overall padding */
    margin-top: 50px; /* Adjust margin for smaller navbars */
  }

  .page-title {
    font-size: 2.2rem;
    margin-bottom: 30px;
  }

  .content-wrapper {
    padding: 20px;
    gap: 20px;
    box-shadow: none; /* No shadow on small mobiles for cleaner look */
  }

  .contact-info-block {
    gap: 20px;
  }

  .info-item {
    flex-direction: column; /* Stack icon and text vertically */
    align-items: center; /* Center items when stacked */
    gap: 10px; /* Space between icon and text */
  }

  .info-icon {
    width: 36px;
    height: 36px;
  }

  .info-text {
    text-align: center; /* Centering info-title and info-subtitle for 768px */
  }

  .info-title {
    font-size: 1.1rem;
  }

  .info-title strong {
    font-size: 1.2rem;
  }

  .info-subtitle,
  .info-link {
    font-size: 0.9rem;
  }

  .map-block {
    height: 300px; /* Slightly smaller map height on mobile */
  }
}

/* Very Small Mobiles (e.g., 480px and below) */
@media (max-width: 480px) {
  .page-title {
    font-size: 1.8rem;
    margin-bottom: 25px;
  }

  .info-icon {
    width: 32px;
    height: 32px;
  }

  .info-text {
    text-align: center; /* Keep centering for 480px and below */
  }

  .info-title {
    font-size: 1rem;
  }

  .info-title strong {
    font-size: 1.1rem;
  }

  .info-subtitle,
  .info-link {
    font-size: 0.85rem;
  }

  .map-block {
    height: 250px;
  }
}
</style>